import { User } from "@ecologi/shared";
import ShoppingBagIcon from "@ecologi/assets/icons/impact-shop/shopping-bag.svg";
import { NavSection } from "@ecologi/react-components/src/NavigationDrawer/navigation";
import { accountDetailsPageTitle } from "../../features/profile/account-details/account-details-page-title";
import { isProduction } from "../../lib/utils/is-production";
import { addIdsToNavSection } from "./add-ids-to-nav-section";

export const getNavSectionsForFundPlatform = ({
  productsInBasket,
  user,
}: {
  user: User;
  productsInBasket?: number;
}): NavSection[] => {
  return [
    [
      {
        label: "Your profile",
        path: user.getProfilePath(),
        route: user.isChildProfile
          ? "/[usernameOrId]/[childUsernameOrId]"
          : "/[usernameOrId]",
      },
      {
        label: "Dashboard",
        path: "/dashboard",
      },
      {
        label: "Project insights",
        path: "/project-insights",
      },
      {
        label: "Impact shop",
        path: "/impact-shop",
        icon: {
          svg: <ShoppingBagIcon />,
          label: productsInBasket > 0 && productsInBasket,
          path: productsInBasket > 0 ? "/impact-shop/basket" : "/impact-shop",
          isHoverDisabled: productsInBasket === 0,
        },
      },
      {
        label: "Badges",
        path: `/${user.username}/badges`,
        route: "/[usernameOrId]/badges",
      },
      ...(user.isBusinessType
        ? [
            {
              label: "Business toolkit",
              path: "/business-toolkit",
            },
            {
              label: "Impact API",
              path: "/impact-api",
            },
          ]
        : []),
      {
        label: "Account",
        links: [
          {
            label: accountDetailsPageTitle(user),
            path: "/account/details",
          },
          {
            label: "Profile settings",
            path: "/account/settings",
          },
          {
            label: "Billing",
            path: "/account/billing",
          },
          {
            label: "Manage subscription",
            path: "/account/manage-subscription",
          },
          {
            label: "Certificates",
            path: "/account/certificates",
          },
        ],
      },
    ],
    ...(user.isBusinessType
      ? [
          [
            {
              label: "Ecologi Zero",
              path: isProduction()
                ? "https://zero.ecologi.com/api/landing-redirect"
                : "https://x.zero.ecologi.com/api/landing-redirect",
            },
          ],
        ]
      : []),
    [
      {
        label: "Help centre",
        path: "https://help.ecologi.com/",
      },
    ],
    [
      {
        label: " Logout",
        path: "/api/logout",
      },
    ],
  ].map(addIdsToNavSection);
};
